import React, { useState } from 'react'
import UserDetails from 'containers/UserDetails'
import { ContainerGeral } from './Styled'

// Componentes
import BannerPrincipal from './Components/BannerPrincipal/BannerPrincipal'
import TarjaCountdown from './Components/TarjaCountdown/TarjaCountdown'
import Planos from './Components/Planos/Planos'
import Coaching from './Components/Coaching/Coaching'

export default function BlackFriday () {

	return (
		<UserDetails showSpinner>
			{details => {

				const [data, setData] = useState(details.blackfriday)

				let planosInitial = data.planos;
				let planos1Ano = data.planos[0].assinaturas;
				let planos2Anos = data.planos[1].assinaturas;

				return (
					<ContainerGeral padding={false}>
						
						{/* Banner Principal */}
						<BannerPrincipal nome={details.name} planos={planosInitial} desconto={details.blackfriday.desconto_ate} />

						{/* Tarja */}
						<TarjaCountdown
							date={new Date()}
							to={details.blackfriday.data_fim}
							onFinish={() => window.location.reload()}
						/>
						
						{/* Planos */}
						<Planos dados={details.blackfriday} planos1Ano={planos1Ano} planos2Anos={planos2Anos} />
	
						{/* Coaching */}
						<Coaching desconto={details.blackfriday.desconto_ate} dataFim={details.blackfriday.data_fim} />
	
					</ContainerGeral>
				)
				
			}}
		</UserDetails>
	)
}
